module.exports = __webpack_public_path__ + "img/clock-waiting.595180dd.png";